<script>
    export default {
        props: ['departments'],

        data() {
            return {
                departmentId: 1,
                departmentManager: null,
                overlayVisible: false,
                overlaySrc: '',
            }
        },

        methods: {
            showDepartment: function(id) {
                this.departmentId = id;

                let users = this.departments[id].users;

                this.departmentManager = users.filter(user => {
                    return user.id == this.departments[id].head_user_id;
                })[0];

                if(! this.departmentManager) {
                    this.departmentManager = this.departments[0].users[0];
                }
            },

            showOverlay(e) {
                this.overlayVisible = true;
                this.overlaySrc = e.target.src + '?w=500&h=500';
            },

            closeOverlay() {
                this.overlayVisible = false;
                this.overlaySrc = '';
            }
        },

        mounted() {
            this.showDepartment(this.departmentId);
        },
    }
</script>

<style lang="scss">
    .is-active {
        color: #d97915 !important;
    }

    .photo-overlay {
        display: flex;
        width: 100vw;
        height: 100vh;
        position: fixed;
        background: rgba(0,0,0,0.6);
        top: 0;
        left: 0;
        justify-content: center;
        align-items: center;

        img {
            width: 500px;
            height: 500px;
            border: 4px solid white;
            border-radius: 4px;
        }
    }
</style>